import React from 'react';
import { ModuleBase, Stack, Text, Link, Box } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import classNames from 'classnames';

const GlobalDataProductivity = (data: SideBySideModuleModel) => {
  const {
    props: { alignment, link1, title, preTitle, cards },
  } = data;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: '#305545' } }}
      className="GlobalDataProductivity overflow-hidden"
    >
      <Stack className={classNames('color-from-bg container flex flex-col justify-between gap-5 lg:mb-10 lg:gap-8')}>
        <div>
          <Text className="text-style-tag uppercase">{preTitle}</Text>
        </div>
        <div className="flex flex-col gap-10 md:flex-row lg:gap-5" data-alignment={alignment}>
          <div className="color-from-bg h-full w-full lg:w-1/2">
            {title && (
              <Text
                className="text-style-h2 xl:!text-[75px] xl:leading-[75px]"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
          </div>
          <div className="color-from-bg relative w-full flex-grow lg:w-1/2">
            {cards && (
              <div className="flex-col">
                {cards.map((card, index) => (
                  <Box
                    key={index}
                    className={classNames(
                      index !== 0 && 'lg:after-extended-line-top border-t lg:border-t-0',
                      'border-from-bg relative flex flex-col gap-1 pt-5 pb-5 first:pt-0',
                    )}
                  >
                    <p className="text-style-h4">{card.title}</p>
                  </Box>
                ))}
              </div>
            )}
            {link1 && (
              <Link
                animate
                className="btn primary !bg-yellow !border-yellow v2 mt-5 !text-[#305545] hover:!border-white hover:!bg-transparent hover:!text-white lg:mt-14"
                link={link1}
              />
            )}
          </div>
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default GlobalDataProductivity;
